import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_ORDER_URL

export const _get = async (productId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `product/${productId}/uom-conversion`,
  })

  return response?.data
}

export const get = (productId) => async () => await _get(productId)

const _show = async (productId, uomConversionId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'GET',
    url: `product/${productId}/uom-conversion/${uomConversionId}`,
  })

  return response?.data
}

export const show = (productId) => async (uomConversionId) => await _show(productId, uomConversionId)

const _store = async (productId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'POST',
    url: `product/${productId}/uom-conversion`,
    data,
  })

  return response?.data
}

export const store = (productId) => async (data) => await _store(productId, data)

const _update = async (productId, uomConversionId, data) => {
  const response = await apiClientV2({
    baseURL,
    method: 'PATCH',
    url: `product/${productId}/uom-conversion/${uomConversionId}`,
    data,
  })

  return response?.data
}

export const update = (productId) => async (uomConversionId, data) =>
  await _update(productId, uomConversionId, data)

const _deleteSingle = async (productId, uomConversionId) => {
  const response = await apiClientV2({
    baseURL,
    method: 'DELETE',
    url: `product/${productId}/uom-conversion/${uomConversionId}`,
  })

  return response?.data
}

export const deleteSingle = (productId) => async (uomConversionId) =>
  await _deleteSingle(productId, uomConversionId)
